import { Component, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { isPlatformBrowser } from '@angular/common';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as UserActions from '../app-store/user/user.actions';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrl: './side-nav.component.scss',
    standalone: true,
    imports: [SharedModule]
})
export class SideNavComponent implements OnInit {
  isMobileScreen = false;
  currentUserRole: string | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private userService: UserService, private authService: AuthService, private router: Router, private store: Store) {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobileScreen = window.innerWidth < 768;
    }
  }

  ngOnInit() {
         this.currentUserRole = this.userService.getCurrentUserRole();
  }

  @HostListener('window:resize', ['$event.target.innerWidth'])
  onResize(width: number) {
    if (isPlatformBrowser(this.platformId)) {
      if (width < 768) {
        this.isMobileScreen = true;
      }
    }
  }

  logout() {
    this.store.dispatch(UserActions.logout());
    this.userService.clearUser();
    this.authService.logout().then(() => {
      this.router.navigate(['/auth/login']);
    });
  }
}